export default __webpack_public_path__ + "static/media/IMG_5358.8e837ce4.WEBP";